<template>
 <div class="bg-gray-100 pt-20 dark:bg-gray-900 min-h-screen">
  <div
   class="
    container
    flex
    items-center
    rounded
    my-6
    dark:bg-gray-800 dark:text-white
    bg-white
    md:w-2/6
    w-4/5
    shadow-md
   "
  >
   <ion-icon name="search"></ion-icon>
   <input
    type="text"
    placeholder="Search Country"
    class="py-2.5 px-3 bg-transparent rounded focus:outline-none"
    @change="Search"
    v-model="Country"
   />
  </div>
  <div v-if="!load" class="container flex gap-7 flex-wrap justify-around">
   <div v-for="co in c[0]" :key="co">
    <Countries :co="co" />
   </div>
  </div>
  <div v-else>
   <Loader />
  </div>
 </div>
</template>

<script>
import Countries from "../components/Countries.vue";
import Loader from "../components/Loader.vue";
export default {
 components: { Countries, Loader },
 data() {
  return {
   msg: "hi",
   c: [],
   load: null,
   Country: "",
  };
 },
 methods: {
  async Search() {
   this.load = true;
   if (this.Country.length > 0) {
    this.c = [];
    let res = await fetch(`https://restcountries.com/v2/name/${this.Country}`);
    let data = await res.json();
    this.c.push(data);
   }
   this.load = null;
  },
 },
 async created() {
  this.load = true;
  console.log(this.load);
  let res = await fetch("https://restcountries.com/v2/all");
  let data = await res.json();
  this.c.push(data);
  this.c[0].map((c) => console.log(c));
  this.load = null;
  console.log(this.load);
 },
};
</script>

<style>
</style>